export const LegacyRoute = {
  BILLING: 'billing',
  BILLING_ADDRESS: 'billing/address',
  BILLING_CREDITCARD: 'billing/creditcard',
  DASH: 'dash',
  FAV_DASH: 'fav/dash',
  GOALS: 'goals',
  LEADS: 'leads',
  MANAGELEADS: 'manageleads',
  QUICKREPORT: 'quickreport',
  REPORTSTUDIO: 'reportstudio',
  INTEGRATIONS: 'integrations',
};

export const LegacyPathName = {
  BILLING: 'billing',
  BILLINGADDRESS: 'billingaddress',
  BILLINGCREDITCARD: 'billingcreditcard',
  DASHBOARDVIEW: 'dashboardview',
  FAV_DASHBOARDVIEW: 'fav_dashboardview',
  GOALS: 'goals',
  LEADS: 'leads',
  MANAGELEADS: 'manageleads',
  QUICKREPORT: 'quickreport',
  REPORTSTUDIOVIEW: 'reportstudioview',
};
